import { getHost, getProtocol } from '@/utils';
import { appInsights } from '@/components/azureAppInsights/AzureAppInsights';
import { IncomingMessage } from 'http';

export const buildAPIUrl = async (req?: IncomingMessage) => {
  if (typeof window !== 'undefined' && window) {
    return '/api';
  } else if (req) {
    const host = getHost(req);
    const protocol = getProtocol(req);
    return `${protocol}//${host}/api`;
  }
  throw new Error('Request object is required to build API URL');
};

export const buildAPIPipeUrl = async (req?: IncomingMessage) => {
  if (typeof window !== 'undefined' && window) {
    return '/apipipe';
  } else if (req) {
    const host = getHost(req);
    const protocol = getProtocol(req);
    return `${protocol}//${host}/apipipe`;
  }
  throw new Error('Request object is required to build API URL');
};

export const responseInterceptor = async (
  response: Response,
  redirectUrlIfLogin?: string,
  surpress404Error?: boolean,
): Promise<any> => {
  if (response.status === 401) {
    if (typeof window !== 'undefined' && window) {
      window.location.href = `/open-login?redirect=${encodeURIComponent(redirectUrlIfLogin || window.location.href || '/')}`;
    } else {
      return new Response(null, {
        status: 401,
        headers: {
          'content-type': 'application/json',
        },
      });
    }
  } else if (response.status === 404 && surpress404Error) {
    console.warn('API 404 Not Found:', response.url);
    return response;
  } else if (response.status >= 300 && response.status < 400) {
    return response;
  } else if (!response.ok) {
    try {
      appInsights.trackException({
        exception: new Error(`API Error: ${response.status} ${response.statusText} - ${response.url}`),
        properties: {
          status: response.status,
          statusText: response.statusText,
          url: response.url,
        },
      });
    } catch (telemetryError) {
      console.error('App Insights API error logging failed:', telemetryError);
    }
    return Promise.reject(response);
  }
  return response;
};

export const toQueryString = (obj: Record<string, any>): string => {
  const params = Object.entries(obj)
    .filter(([, v]) => v !== undefined && v !== null) // skip empty values
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');

  return params ? `?${params}` : '';
};

export * from './ai-data';
export * from './article-tools';
export * from './page-data';
export * from './report-data';
export * from './stylus-subscription';
export * from './media-data';
export * from './text-to-speech';
export * from './coming-soon';
export * from './scrapbook-data';
export * from './statbank-data';
export * from './services-data';
export * from './personalisation-config';
export * from './notification-data';
export * from './nova-data';
export * from './nova-ava';
export * from './global-data-integration';
export * from './integration';
export * from './services-data';
